import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./utils/redux/store";
import { Provider } from "react-redux";
import { AppProvider } from "./AppContext";
import { LayoutProvider } from "./LayoutContext";
import { PopupProvider } from "./PopupContext";
import { LoadScript } from "@react-google-maps/api";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const root = ReactDOM.createRoot(document.getElementById("root"));
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PK);

root.render(<Elements stripe={stripePromise}>{setContextProviders(<App />)}</Elements>);
function setContextProviders(children) {
    return (
        <Provider store={store}>
            <AppProvider>
                <LayoutProvider>
                    <PopupProvider>
                        <LoadScript
                            googleMapsApiKey={process.env.REACT_APP_MAP_KEY}
                            loadingElement={<div style={{ height: "100%" }} />}>
                            {children}
                        </LoadScript>
                    </PopupProvider>
                </LayoutProvider>
            </AppProvider>
        </Provider>
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
